import { render, staticRenderFns } from "./diseaselist.vue?vue&type=template&id=480d32d1"
import script from "./diseaselist.vue?vue&type=script&lang=js"
export * from "./diseaselist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480d32d1')) {
      api.createRecord('480d32d1', component.options)
    } else {
      api.reload('480d32d1', component.options)
    }
    module.hot.accept("./diseaselist.vue?vue&type=template&id=480d32d1", function () {
      api.rerender('480d32d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/diseaselist.vue"
export default component.exports